const UserEndpoints = {
  getUser: {
    method: 'GET',
    url: (uid: string) => `/users/${uid}`,
  },
} as const;

// Create type from the object
type UserEndpoints = typeof UserEndpoints;

export type { UserEndpoints };
export default UserEndpoints;
